import React from 'react';

interface Props {
  /**
   * `compact: true` removes the full-viewport (100vh) wrapper, making the
   * loader suitable for section/inline usage (e.g. inside a scrollable
   * area). Default is full-screen.
   */
  compact?: boolean;
}

/**
 * Full-screen page-level loader.
 *
 * Visually identical to the App-level `SplashScreen` (clock hands), so the
 * entire opening sequence — pre-React HTML splash → auth bootstrap → first
 * page's initial fetch — shows ONE consistent loader instead of three
 * different spinners flashing in a row.
 *
 * Use `compact` prop for inline section loaders.
 *
 * CSS lives in `src/index.css` under the `bl-splash-*` namespace.
 */
export const PageLoader: React.FC<Props> = ({ compact = false }) => {
  const clock = (
    <div
      className="bl-splash-clock"
      role="status"
      aria-label="Yuklanmoqda"
    >
      <div className="bl-splash-hand bl-splash-hand-hour" />
      <div className="bl-splash-hand bl-splash-hand-min" />
    </div>
  );

  if (compact) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '48px 16px',
        }}
      >
        {clock}
      </div>
    );
  }

  return <div className="bl-splash-wrapper">{clock}</div>;
};

export default PageLoader;
